import { Languages, LogOut, User } from "lucide-react";
import useCurrentUser from "@/store/useCurrentUser";
import { useLogout } from "@/features/auth/api/auth-api";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { USER_ROLE_LABELS, type UserRole } from "@/types/user";
import {
  usePortalLanguage,
  type PortalLanguage,
} from "@/features/portal/store/usePortalLanguage";

const LANGUAGE_LABELS: Record<PortalLanguage, string> = {
  en: "English",
  ar: "العربية",
};

const AvatarMenu = () => {
  const user = useCurrentUser((state: any) => state.user);
  const logout = useLogout();
  const language = usePortalLanguage((state) => state.language);
  const toggleLanguage = usePortalLanguage((state) => state.toggle);

  const initials = (user?.fullName ?? "")
    .split(" ")
    .map((n: string) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="shrink-0 flex items-center justify-center focus:outline-none w-8 h-8 rounded-full bg-(--color-info-500) text-white text-xs font-medium"
          aria-label="Account menu"
        >
          {initials || "?"}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-56">
        <DropdownMenuLabel className="flex flex-col">
          <span className="text-(--color-text-primary)">{user?.fullName}</span>
          <span className="text-xs font-normal text-(--color-text-tertiary)">
            {user?.role ? USER_ROLE_LABELS[user.role as UserRole] : ""}
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem>
          <User className="w-4 h-4" />
          Profile
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => toggleLanguage()}>
          <Languages className="w-4 h-4" />
          <span className="flex-1">Language</span>
          <span className="text-(--color-text-tertiary) text-xs">
            {LANGUAGE_LABELS[language]}
          </span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem variant="destructive" onClick={() => logout()}>
          <LogOut className="w-4 h-4" />
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AvatarMenu;
